module.exports = __webpack_public_path__ + "static/media/bulma-logo.6bf9b4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/bulma-logo.png
// module id = 275
// module chunks = 0